import type { FunctionComponent } from 'react';

import { Button } from '@dr.pogodin/react-utils';

import IconPlus from 'assets/images/icon-circled-plus-24px.svg';

import './style.scss';

type PropsT = {
  disabled?: boolean;
  hideLabelOnMobile?: boolean;
  label: string;
  onClick?: () => void;
  to?: string;
};

const AddNewButton: FunctionComponent<PropsT> = ({
  disabled,
  hideLabelOnMobile,
  label,
  onClick,
  to,
}) => (
  <Button disabled={disabled} onClick={onClick} to={to}>
    <div styleName="content">
      <IconPlus />
      <span styleName={`label ${hideLabelOnMobile ? 'hideOnMobile' : ''}`}>
        {label}
      </span>
    </div>
  </Button>
);

export default AddNewButton;
